import React from 'react';
import equal from 'deep-equal';
import {
  FlatButton,
  Dialog,
  ListItem,
  List,
  TextField,
  CardHeader,
  CardText,
  IconButton,
  CardActions,
  SelectField,
  MenuItem,
  CircularProgress,
} from 'material-ui';
import Refresh from 'material-ui/svg-icons/navigation/refresh';
import Check from 'material-ui/svg-icons/action/check-circle';
import Close from 'material-ui/svg-icons/navigation/close';

import plz from 'await-plz';

import { callApi } from '../client/apiToolbox';
import { API_BASE_URL } from '../App';
import passGen from '../utils/passwordGenerator';

const requestKeys = [
  'placeClone',
  'placeSetName',
  'createUser',
  'rootSetPlaces',
];

const post = (url, body) => callApi(url, 'POST', { 'Content-Type': 'application/json' }, body);

const cleanState = () => ({
  open: false,
  started: false,
  oldId: '',
  newId: '',
  newName: '',
  username: '',
  password: passGen(),
  fetching: [],
  done: [],
  failed: [],
});

class VenueBookingSetup extends React.Component {
  constructor(props) {
    super(props);
    this.state = cleanState();
  }

  shouldComponentUpdate = (nextProps, nextState) => !equal(this.props, nextProps) || !equal(this.state, nextState);

  componentWillUpdate = async (nextProps, nextState) => {
    if (!this.state.open && nextState.open) {
      const url = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
      const [resErr, venues] = await plz(fetch(`${url}/utils/parse/place`, { credentials: 'include' }));
      if (resErr || !venues) return console.error('failed to fetch venue', resErr);
      return this.setState({ venues });
    }
    return null;
  }

  save = async () => {
    const { venueId } = this.props;
    const { oldId, newId, newName, username, password } = this.state;

    let err;
    this.setState({ fetching: [...this.state.fetching, 'placeClone'] });
    [err] = await plz(post(`${API_BASE_URL}/utils/parse/place/clone`, { oldId, newId }));
    this.afterSave('placeClone', err);

    this.setState({ fetching: [...this.state.fetching, 'placeSetName'] });
    [err] = await plz(post(`${API_BASE_URL}/utils/parse/place/set-name`, { id: newId, name: newName, venueId }));
    this.afterSave('placeSetName', err);

    this.setState({ fetching: [...this.state.fetching, 'createUser'] });
    [err] = await plz(post(`${API_BASE_URL}/utils/parse/user`, { placeId: newId, username, password }));
    this.afterSave('createUser', err);

    this.setState({ fetching: [...this.state.fetching, 'rootSetPlaces'] });
    [err] = await plz(post(`${API_BASE_URL}/utils/parse/root/set-places`));
    this.afterSave('rootSetPlaces', err);
  };

  beforeSave = (key) => this.setState({ fetching: [...this.state.fetching, key] });
  afterSave = (key, err) => this.setState({ fetching: this.state.fetching.filter((f) => f !== key), [err ? 'failed' : 'done']: [...this.state[err ? 'failed' : 'done'], key] });

  generatePassword = () => this.setState({ password: passGen() });

  toggle = () => this.setState({ ...cleanState(), open: !this.state.open });

  menuItems = (oldId, venues) => (
    venues && venues.map((venue) => (
      <MenuItem
        key={venue.placeId}
        value={venue.placeId}
        primaryText={venue.placeId}
        checked={oldId && oldId === venue.placeId}
        insetChildren
      />
    ))
  );

  form = ({ oldId, newId, newName, username, password, venues }) => (
    <div>
      <CardHeader
        title="Place information"
        style={{ paddingBottom: 0 }}
      />
      <CardText style={{ display: 'flex', flexDirection: 'column', paddingTop: 0 }}>
        <SelectField
          floatingLabelText="Place to Clone"
          value={oldId}
          onChange={(e, i, val) => this.setState({ oldId: val })}
        >
          {this.menuItems(oldId, venues)}
        </SelectField>
        <TextField onChange={(e, val) => this.setState({ newId: val })} required floatingLabelText="New place ID" value={newId} />
        <TextField onChange={(e, val) => this.setState({ newName: val })} required floatingLabelText="New place Name" value={newName} />
      </CardText>
      <CardHeader
        title="User information"
        style={{ paddingBottom: 0 }}
      />
      <CardText style={{ display: 'flex', flexDirection: 'column', paddingTop: 0 }}>
        <TextField onChange={(e, val) => this.setState({ username: val })} required floatingLabelText="Username" value={username} />
        <div>
          <TextField onChange={(e, val) => this.setState({ password: val })} required floatingLabelText="Password" value={password} />
          <IconButton
            style={{ width: 35, height: 18, padding: 4 }}
            iconStyle={{ width: 16, height: 16 }}
            onClick={this.generatePassword}
          >
            <Refresh />
          </IconButton>
        </div>
      </CardText>
      <CardActions style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
        <FlatButton label="Cancel" onClick={this.toggle} />
        <FlatButton
          onClick={() => {
            this.setState({ started: true });
            this.save();
          }}
          disabled={!oldId || !newId || !newName || !username || !password}
          label="Go!"
        />
      </CardActions>
    </div>
  );

  progress = ({ fetching }) => (
    <div>
      <CardHeader
        title="Place information"
        style={{ paddingBottom: 0 }}
      />
      <CardText style={{ display: 'flex', flexDirection: 'column', paddingTop: 0 }}>
        <List>
          {requestKeys.map((key) => (
            <ListItem
              primaryText={key}
              rightIcon={
                this.state.fetching.includes(key) ?
                  <CircularProgress size={20} /> :
                  this.state.done.includes(key) ?
                    <Check /> :
                    this.state.failed.includes(key) ?
                      <Close style={{ color: 'red' }} /> :
                      <Close />
              }
            />
          ))}
        </List>
      </CardText>
      <CardActions style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
        <FlatButton primary onClick={this.toggle} disabled={fetching.length > 0} label="Done" />
      </CardActions>
    </div>
  );

  render() {
    const { open, started } = this.state;
    const Form = this.form;
    const Progress = this.progress;
    return (
      <FlatButton
        onClick={this.toggle}
        primary
        label="Booking Setup"
      >
        <Dialog
          open={open}
          onRequestClose={this.toggle}
        >
          {
            started ? (
              <Progress {...this.state} />
            ) : (
              <Form {...this.state} />
            )
          }
        </Dialog>
      </FlatButton>
    );
  }
}

export default VenueBookingSetup;
